// extracted by mini-css-extract-plugin
module.exports = {"root":"n_pZ","wrapper":"n_p0","image":"n_p1 h_dp h_dr h_dP","crop":"n_p2","round":"n_p3","fixedHeight":"n_p4"};